import welcome from './welcome.svg';
import video from './video.svg';
import videoPlay from './video-play.svg';
import tabs from './tabs.svg';
import richText from './rich-text.svg';
import recommend from './recommend.svg';
import practiceChannel from './practice-channel.svg';
import popularSpeech from './popular-speech.svg';
import picture from './picture.svg';
import pictureCover from './picture-cover.svg';
import lineSplitContent from './line-split-content.svg';
import graphical from './graphical.svg';
import faq from './faq.svg';
import document from './document.svg';
import departmentRank from './department-rank.svg';
import dayTask from './day-task.svg';
import courseRankings from './course-rankings.svg';
import coreData from './core-data.svg';
import comment from './comment.svg';
import carousel from './carousel.svg';
import autoRecommend from './auto-recommend.svg';
import appstore from './appstore.svg';
import api from './api.svg';
import alert from './alert.svg';

export const iconMap: Record<string, string> = {
    welcome,
    video,
    videoPlay,
    tabs,
    richText,
    recommend,
    practiceChannel,
    popularSpeech,
    picture,
    pictureCover,
    lineSplitContent,
    graphical,
    faq,
    document,
    departmentRank,
    dayTask,
    courseRankings,
    coreData,
    comment,
    carousel,
    autoRecommend,
    appstore,
    api,
    alert,
};
